import { createFileRoute } from '@tanstack/react-router';

import { loadWalletMessages, loadWalletScreens, walletListScreen, walletListSearch } from '@/modules/wallet/route';
import { lazyScreen } from '@/shared/screen';

// Carteiras no caminho do menu do legado (`router.tsx:1356-1361`): `screens.byPath` acha o manifesto e o
// menu vira link interno. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/gestao-carteira/carteiras/')({
  validateSearch: walletListSearch,
  staticData: { screen: walletListScreen },
  loader: loadWalletMessages,
  component: lazyScreen(loadWalletScreens, 'WalletListScreen'),
});
